import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';

const Card = ({ className, id, children, url }) => {
  const cardClasses = cn(
    'relative flex flex-col w-full p-[1.75em_1.625em] bg-white border-2 border-[#e3e3e3] rounded-[3px] leading-none text-[#393939]',
    className
  );

  const cardContent = (
    <div id={id} className={cardClasses}>
      {children}
    </div>
  );

  if (url) {
    return (
      <NavLink
        to={url}
        className={({ isActive }) =>
          cn(
            'block !no-underline group hover:!no-underline',
            isActive && 'isSelected'
          )
        }
      >
        <div 
          id={id} 
          className={cn(
            cardClasses,
            'group-hover:bg-[#f9f9f9] transition-colors',
            'group-[.isSelected]:border-[#a6a6a6] group-[.isSelected]:shadow-[inset_0_0_0_1px_#a6a6a6]',
            'group-[.isSelected]:after:content-[""] group-[.isSelected]:after:absolute group-[.isSelected]:after:top-1/2 group-[.isSelected]:after:-translate-y-1/2 group-[.isSelected]:after:-right-[17px] group-[.isSelected]:after:border-[9px] group-[.isSelected]:after:border-transparent group-[.isSelected]:after:border-l-white group-hover:group-[.isSelected]:after:border-l-[#f9f9f9]',
            'group-[.isSelected]:before:content-[""] group-[.isSelected]:before:absolute group-[.isSelected]:before:top-1/2 group-[.isSelected]:before:-translate-y-1/2 group-[.isSelected]:before:-right-[22px] group-[.isSelected]:before:border-[10px] group-[.isSelected]:before:border-[#eeeeee] group-[.isSelected]:before:border-l-[#a6a6a6]'
          )}
        >
          {children}
        </div>
      </NavLink>
    );
  }

  return cardContent;
};

Card.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
};

Card.defaultProps = {
  id: null,
  className: null,
  url: null,
};

export default Card;
